import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bus from '@/utils/bus';
import { fetchChangeChargeStatus } from '@/api/PMS/customerService/leaseContract/contractList';
import { fetchDelete, fetchDetail } from '@/api/PMS/customerService/leaseContract/contractList';
export default {
  props: {
    showDialog: Boolean,
    isConfirm: Boolean,
    // 是否确认退租
    keyValue: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      areaId: '',
      title: '',
      activeNames: '1',
      contractState: '',
      // 合同状态
      childData: {
        leaseType: 1
      },
      multipleSelection: [],
      houseList: [],
      parkingLotList: [],
      houseBillList: [],
      standardList: [],
      parkLotBillList: [],
      loading: false,
      dialogFormVisible: false,
      dialogCustomerVisible: false,
      dialogHistoryVisible: false
    };
  },
  computed: {
    //  金额计算
    moneyCostObj: function moneyCostObj() {
      var receivable = this.resourceList.reduce(function (prev, curr) {
        // 应收
        return prev + curr;
      }, 0);
      var returned = this.resourceList.reduce(function (prev, curr) {
        // 应退
        return prev + curr;
      }, 0);
      var receivableTotal = receivable + returned; // 总计应收

      var obj = {
        receivable: receivable,
        returned: returned,
        receivableTotal: receivableTotal
      };
      return obj;
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      bus.$on('returnRent', function (obj) {
        // 接收退租日期
        _this.childData = obj;
        console.log('obj', _this.childData);
      }); // this.getDetail(this.keyValue)
    },
    getDetail: function getDetail(id) {
      var _this2 = this;

      this.listLoading = true;

      if (this.isConfirm) {
        fetchDetail({
          id: id
        }).then(function (res) {
          if (res.data.code === 200) {
            _this2.childData = res.data.data;
          }

          _this2.listLoading = false;
        });
      } else {
        fetchDetail({
          id: id
        }).then(function (res) {
          if (res.data.code === 200) {
            _this2.childData = res.data.data;
          }

          _this2.listLoading = false;
        });
      }
    },
    handleMoneyChange: function handleMoneyChange(val, index) {
      // 计算应收/退金额
      var money = val - this.childData[index].money;
      this.$set(this.childData[index], '', money);
    },
    handleUpdate: function handleUpdate() {
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    handleDelete: function handleDelete() {
      var _this3 = this;

      this.$confirm('你确定是要删除该房间, 是否继续?', '提示').then(function () {
        fetchDelete([_this3.keyValue]).then(function (response) {
          _this3.$emit('handDetailCancle');

          _this3.Alert({
            alertType: 'delete'
          });
        });
      });
    },
    // 上一步
    handlePrev: function handlePrev() {
      this.$emit('handCancle', 'returnRent');
    },
    // 确认退租
    handleReturnRent: function handleReturnRent() {
      var _this4 = this;

      this.$confirm('是否确认退租?确认后操作不可撤销,请仔细核对相关金额', '提示').then(function () {
        // this.$emit('handCancle', 'confirmReturnRent')
        var updateParams = {
          contractType: 5
        };
        updateParams.id = _this4.childData.id;
        updateParams.leaseType = _this4.childData.leaseType;
        updateParams.refundDate = _this4.childData.refundDate;
        fetchChangeChargeStatus(updateParams).then(function (res) {
          if (res.data.code === 200) {
            _this4.Alert({
              alertType: 'update',
              message: '退租成功'
            });

            _this4.$emit('handCancle');
          }
        });
      });
    },
    // 补打票据
    handleLatePlayBill: function handleLatePlayBill() {
      this.$emit('handCancle', 'pirntBill');
    },
    // 确认
    handleConfirm: function handleConfirm() {},
    handCancle: function handCancle() {
      this.$emit('handCancle');
    }
  }
};